import { axios } from '../../../axios';

const getNotifications = async () => {
  try {
    const res = await axios.get("/users/notifications");
    return res?.data?.data || [];
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
};


export {getNotifications}